module.exports = __webpack_public_path__ + "img/tts.09593576.jpg";